module.exports = "https://static.wagwalking.com/_next/static/images/dog-walking-city-video-section-mobile-18404415f6343f619b9309cba7f9df79.jpg";